import { render } from "./Pagination.vue?vue&type=template&id=3433e948"
import script from "./Pagination.vue?vue&type=script&lang=js"
export * from "./Pagination.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/admin/Pieces/Pagination.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3433e948"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3433e948', __exports__)) {
    api.reload('3433e948', __exports__)
  }
  
  module.hot.accept("./Pagination.vue?vue&type=template&id=3433e948", () => {
    api.rerender('3433e948', render)
  })

}


export default __exports__